import styles from "./index.module.scss"

interface EmptyRepoProps {
  gitDir: string,
  renameHost: boolean
}

export const EmptyRepo = (props: EmptyRepoProps) => {
  // Users can use the renamed url instead of localhost, givent their local git server is using supported versions
  const remoteHost = props.renameHost ? "http://internal.degit.io:21560" : "http://localhost:21560"

  return (
    <div className={styles.NewRepoContainer}>
      <div className={styles.NewRepoSubHeader}>Create a new repository on the command line</div>
      <div className={styles.NewRepoRow}>
        <div>echo "# README" {">>"} README.md</div>
        <div>git init</div>
        <div>git add README.md</div>
        <div>git commit -m "first commit"</div>
        <div>git branch -M master</div>
        <div>git remote add origin {remoteHost}/git{props.gitDir}</div>
        <div>git push -u origin master</div>
      </div>

      <div className={styles.NewRepoSubHeader}>
        Push an existing repository from the command line
      </div>
      <div className={styles.NewRepoRow}>
        <div>git remote add origin {remoteHost}/git{props.gitDir}</div>
        <div>git branch -M master</div>
        <div>git push -u origin master</div>
      </div>
    </div>
  )
}
